import script from "./AutoOfferRules.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoOfferRules.vue?vue&type=script&setup=true&lang=js"

import "./AutoOfferRules.vue?vue&type=style&index=0&id=86c202a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86c202a8"]])

export default __exports__